import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import "./translations";

import { CustomChip } from "@/components/customChip/CustomChip";

interface MarketPriceIndicatorProps {
  propertyPrice?: number | null;
  marketValue?: number | null;
}

export const MarketPriceIndicator = ({ propertyPrice, marketValue }: MarketPriceIndicatorProps): JSX.Element | null => {
  const { t } = useTranslation("MarketAnalysisPanel");

  if (propertyPrice && marketValue) {
    const difference = Math.abs(Number(((marketValue / propertyPrice - 1) * 100).toFixed(2)));
    if (difference <= 1)
      return (
        <CustomChip
          label={`${difference.toLocaleString("de-DE")}% ${t("difference")}`}
          chipType="success"
          tooltip={{ content: t("priceDeviation") }}
        />
      );
    if (difference <= 10)
      return (
        <CustomChip
          label={`${difference.toLocaleString("de-DE")}% ${t("difference")}`}
          chipType="warning"
          tooltip={{ content: t("priceDeviation") }}
        />
      );
    return (
      <CustomChip
        label={`${difference.toLocaleString("de-DE")}% ${t("difference")}`}
        chipType="error"
        tooltip={{ content: t("priceDeviation") }}
      />
    );
  }

  return null;
};
